module.exports = __webpack_public_path__ + "media/insights/skills_icon-a2ccbe50.png";